import {Injectable} from '@angular/core';

@Injectable()
export  class SetConditionOption {
  condition: any;
  selectedItem: any;
  index: number;
  onSave: any;
  onCancel: any;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/rules/model/Set-condition.option.service.ts